export const CANADA_ZIP_CODE_REGEX = new RegExp(/^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/);
export const US_ZIP_CODE_REGEXT = new RegExp(/^\d{5}[-]?(?:\d{4})?$/);
